import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import TimeSlotGrid from '../components/TimeSlotGrid';
import { useAvailability } from '../hooks/useAvailability';
import { Clock } from 'lucide-react';

interface StepTimeProps {
  restaurantId: string;
  date: Date;
  partySize: number;
  selectedTime: string | null;
  onSelect: (time: string) => void;
  onAutoAdvance: () => void;
  onAllSlotsFull?: (full: boolean) => void;
}

const StepTime: React.FC<StepTimeProps> = ({
  restaurantId, date, partySize, selectedTime, onSelect, onAutoAdvance, onAllSlotsFull,
}) => {
  const { slots, services, loading, error, fetchAvailability } = useAvailability(restaurantId);

  useEffect(() => {
    fetchAvailability(date, partySize);
  }, [date, partySize, fetchAvailability]);

  // Notify parent if all slots are full
  useEffect(() => {
    if (!loading && slots.length > 0 && onAllSlotsFull) {
      const allFull = slots.every(s => s.status === 'full');
      onAllSlotsFull(allFull);
    }
  }, [slots, loading, onAllSlotsFull]);

  const handleSelect = (time: string) => {
    onSelect(time);
    setTimeout(() => onAutoAdvance(), 300);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.25 }}
      className="flex flex-col gap-4 py-2 px-1"
    >
      <div className="flex items-center gap-2 text-muted-foreground justify-center">
        <Clock className="h-5 w-5" />
        <span className="text-sm font-medium">Choisissez un créneau</span>
      </div>
      <TimeSlotGrid
        slots={slots}
        services={services}
        selectedTime={selectedTime}
        loading={loading}
        error={error}
        onSelect={handleSelect}
      />
    </motion.div>
  );
};

export default StepTime;
